export const featureKey = 'genesysCloudWebDeployments';
